import React from "react";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import MainPagination from "../Common/MainPagination";

const EarningDetialsOrderList = ({
  isError,
  isLoading,
  details,
  eventDetails,
  getDetails,
}) => {
  const items = details?.data?.itemsList || [];

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <MainPagination getEventsMethod={getDetails} MainData={details}>
        <div className="event-earning-detail-table-wrap is-wide">
          <table className="event-earning-detail-table is-orders">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Ticket Cost</th>
                <th scope="col">Payment Type</th>
                <th scope="col">Service Fee({eventDetails?.serviceFee}%)</th>
                <th scope="col">Promocode</th>
                <th scope="col">
                  Promoter Commission({eventDetails?.commissionAmount}%)
                </th>
                <th scope="col">
                  Danzflo Fee({process.env.REACT_APP_DANZFLO_COMMISSION}%)
                </th>
                <th scope="col">
                  Merchant Fee({process.env.REACT_APP_MERCHANT_FEE}%+30 cent)
                </th>
                <th scope="col">Refunded Amount</th>
                <th scope="col">Organizer Earning</th>
                <th scope="col">Escrowed Amount</th>
                <th scope="col">Remaining</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.length > 0 ? (
                items.map((item, index) => (
                  <tr key={item?._id || index}>
                    <td>
                      {item?.billingDetails?.firstName}{" "}
                      {item?.billingDetails?.lastName}
                    </td>
                    <td>
                      USD{" "}
                      {parseFloat(
                        (item?.subtotal || 0) + (item?.discount || 0)
                      ).toFixed(2)}
                    </td>
                    <td className="is-multiline">
                      {item?.paymentType === "emi"
                        ? "Split"
                        : item?.paymentType}{" "}
                      {item?.paymentType === "emi" && (
                        <span>({item?.emiInstallment} Days)</span>
                      )}
                    </td>
                    <td>+USD {parseFloat(item?.serviceFee || 0).toFixed(2)}</td>
                    <td>-USD {parseFloat(item?.discount || 0).toFixed(2)}</td>
                    <td>
                      -USD {parseFloat(item?.promoterAmount || 0).toFixed(2)}
                    </td>
                    <td>
                      -USD {parseFloat(item?.adminAmount || 0).toFixed(2)}
                    </td>
                    <td>-USD {parseFloat(item?.merchantFee || 0).toFixed(2)}</td>
                    <td>
                      -USD{" "}
                      {item?.refundedAmount
                        ? parseFloat(item.refundedAmount).toFixed(2)
                        : "0.00"}
                    </td>
                    <td>
                      USD {parseFloat(item?.organizerAmount || 0).toFixed(2)}
                    </td>
                    <td>
                      {parseFloat(item?.totalAmountOfTransaction || 0).toFixed(2)}
                    </td>
                    <td>
                      {parseFloat(
                        (item?.total || 0) - (item?.totalAmountOfTransaction || 0)
                      ).toFixed(2)}
                    </td>
                    <td>
                      {item?.paymentType === "emi" &&
                      item?.totalPaidEmi === item?.emiInstallment
                        ? "Full Paid"
                        : item?.paymentType === "emi"
                        ? "Partially Paid"
                        : "Full"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={13}>
                    <div className="event-earning-detail-not-found">
                      No orders found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </MainPagination>
    </MainComponentWrapper>
  );
};

export default EarningDetialsOrderList;
